export const SET_PREFERENCES = 'SET_PREFERENCES';
